import colorPalette from './main/color-palette';
import { getCustomTheme } from './main/theme'; // './debug/theme'

const getThemeColors = () => {
  const namedColors = getCustomTheme(colorPalette);
  return {
    ...colorPalette,
    ...namedColors
  };
};
const colors = getThemeColors();
const smallestFont = 12; // 10
const fontSizes = {
  '2xs': smallestFont,
  xs: smallestFont + 2,
  sm: smallestFont + 4,
  md: smallestFont + 6,
  lg: smallestFont + 8,
  xl: smallestFont + 10,
  '2xl': smallestFont + 14,
  '3xl': smallestFont + 20,
  '4xl': smallestFont + 26,
  '5xl': smallestFont + 38,
  '6xl': smallestFont + 50,
  '7xl': smallestFont + 62,
  '8xl': smallestFont + 86,
  '9xl': smallestFont + 118
};
const breakpoints = {
  base: 0,
  '3xs': 350,
  '2xs': 400,
  xs: 450,
  sm: 480,
  '2sm': 500,
  md: 768,
  lg: 992,
  xl: 1200,
  '2xl': 1536
};
export { colors, fontSizes, breakpoints };
//# sourceMappingURL=index.js.map